module.exports = __webpack_public_path__ + "static/media/instagram.f939292a.png";